<template>
  <v-dialog v-model="exibirRascunhoDialog" width="600">
    <v-card>
      <v-card-title class="headline primary white--text" primary-title
        >Motivo da 2ª Via</v-card-title
      >
      <v-card-text class="pa-0">
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
        ></v-progress-linear>
        <v-stepper v-model="etapa">
          <v-stepper-header>
            <v-stepper-step :complete="etapa > 1" step="1"
              >Motivo</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step :complete="etapa > 2" step="2"
              >Anexos</v-stepper-step
            >
            <v-divider></v-divider>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <etapa-motivo-segunda-via
                :loading="loading"
                :movimento-id="movimentoId"
                @cancelar="limparRascunho"
                @criar-rascunho="criarRascunho"
              ></etapa-motivo-segunda-via>
            </v-stepper-content>
            <v-stepper-content step="2">
              <etapa-anexo-segunda-via
                :loading="loading"
                :movimento-id="movimentoId"
                @altera-loading="alteraLoading"
                @cancelar="limparRascunho"
                @gerar-segunda-via="gerarSegundaVia"
              ></etapa-anexo-segunda-via>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import { WEB_SERVICE } from "@/constants";

import {
  segundaViaCriarRascunho,
  enviarMovimentoParaAuditoria,
  segundaViaPrepararEnvio
} from "@/services/movimentos";

import EtapaAnexoSegundaVia from "./etapa-anexos";
import EtapaMotivoSegundaVia from "./etapa-motivo";

const { mapMutations } = createNamespacedHelpers("portal");

export default {
  name: "EtapasRascunhoSegundaVia",
  props: {
    codigoBeneficiario: String,
    exibirRascunhoDialog: Boolean,
    usuarioId: Number
  },
  components: { EtapaAnexoSegundaVia, EtapaMotivoSegundaVia },
  computed: {},
  data() {
    return {
      etapa: 0,
      loading: false,
      movimentoId: null
    };
  },
  methods: {
    ...mapMutations(["setErrorToast", "setToast"]),
    alteraLoading(valor) {
      this.loading = valor;
    },
    criarRascunho(dadosRascunho) {
      this.loading = true;

      const rascunho = {
        ...dadosRascunho,
        codigoBeneficiario: this.codigoBeneficiario,
        usuarioId: this.usuarioId
      };

      segundaViaCriarRascunho(rascunho)
        .then(response => {
          this.movimentoId = response;
          this.etapa = 2;
        })
        .catch(({ response }) => {
          let errorMessage = response.data?.message;
          errorMessage = errorMessage.split(": ")[1] || errorMessage;

          const resultado = errorMessage.split("|");

          if (WEB_SERVICE.includes(resultado[0])) {
            this.setErrorToast(errorMessage);
          } else {
            this.setToast(
              response.data ? response.data.message : response.message
            );
          }
        })
        .finally(() => (this.loading = false));
    },
    gerarSegundaVia() {
      this.loading = true;

      segundaViaPrepararEnvio(this.movimentoId)
        .then(async () => {
          await enviarMovimentoParaAuditoria(this.movimentoId).then(() => {
            this.setToast(
              "Sua solicitação foi confirmada, ela será analisada pela Unimed."
            );
          });
        })
        .catch(({ response }) => {
          const resultado = response?.data?.message.split("|");

          if (WEB_SERVICE.includes(resultado[0])) {
            this.setErrorToast(response?.data?.message);
          } else {
            this.setToast(response?.data?.message);
          }
        })
        .finally(() => {
          this.limparRascunho();
        });
    },
    limparRascunho() {
      this.etapa = 1;
      this.loading = false;
      this.movimentoId = null;
      this.$emit("ocultar-rascunho-dialog");
    }
  }
};
</script>
